import type { InferOutput } from "valibot";

export const productDocumentSchema = v.object({
  product_id: v.number(),
  name: v.string(),
  permalink: v.pipe(v.string(), v.url()),
  timestamp: v.number(),
  price: v.number(),
  regular_price: v.number(),
  msrp_price: v.number(),
  sale_price: v.optional(v.number()),
  on_sale: v.boolean(),
  in_stock: v.boolean(),
  pre_order: v.boolean(),
  pre_order_timestamp: v.optional(v.number()),
  image_url: v.pipe(v.string(), v.url()),
  short_description: v.string(),
  is_featured: v.boolean(),
  categories: v.array(v.string()),
  product_age_min: v.optional(v.number()),
  product_age_max: v.optional(v.number()),
  game_nb_players_min: v.optional(v.number()),
  game_nb_players_max: v.optional(v.number()),
  game_duration_min: v.optional(v.number()),
  game_duration_max: v.optional(v.number()),
  puzzle_nb_pieces: v.optional(v.number()),
  pa_collection: v.optional(v.array(v.string())),
  pa_langue: v.optional(v.array(v.string())),
  pa_marque: v.optional(v.array(v.string())),
  pa_mecanique: v.optional(v.array(v.string())),
  pa_niveau: v.optional(v.array(v.string())),
  pa_public_cible: v.optional(v.array(v.string())),
  pa_type_de_bricolage: v.optional(v.array(v.string())),
  pa_type_de_casse_tete: v.optional(v.array(v.string())),
  pa_type_de_jeu: v.optional(v.array(v.string())),
});
export type ProductDocument = InferOutput<typeof productDocumentSchema>;
